function toggleStickyATC() {
  const stickyATC = document.querySelector(".sticky-atc");
  stickyATC.classList.toggle("open");
}

function openStickyATC() {
  const stickyATC = document.querySelector(".sticky-atc");
  stickyATC.classList.add("open");
  stickyATC.setAttribute("tabindex", "0");
}

function closeStickyATC() {
  const stickyATC = document.querySelector(".sticky-atc");
  stickyATC.classList.remove("open");
  stickyATC.setAttribute("tabindex", "-1");
}

function scrollStickyATC() {
  const stickyATC = document.querySelector(".sticky-atc");
  const activeElement = document.activeElement;
  const isFocusInsideStickyATC = stickyATC && stickyATC.contains(activeElement);

  if (window.innerWidth > 768) {
    if (window.pageYOffset > 500) {
      openStickyATC();
    } else if (!isFocusInsideStickyATC) {
      closeStickyATC();
    }
    // If focus is inside, do not close
  } else if (!isFocusInsideStickyATC) {
    closeStickyATC();
  }
}

document.addEventListener("DOMContentLoaded", scrollStickyATC);
document.addEventListener("scroll", scrollStickyATC, { passive: true });
